import { useTranslation } from 'react-i18next';
import { MaintenanceTable } from '../Layouts/DataTable';
import { EApiType, EDataMaintenanceType, EModuleType } from '../../data/Constants';
import { getSalesText } from '../../store/states/SalesTextSlice';
import { useApiError } from '../../hooks';

import type { IManagementProps } from '../../../types';

export const SalesText = (props: IManagementProps) => {
  const { t } = useTranslation();
  const errorElement = useApiError(EApiType.SalesTextKey);

  if (errorElement) return errorElement;

  return (
    <>
      <h3 className="mainHeader"> {t('header.salesText')} </h3>
      <MaintenanceTable
        token={props.token}
        type={EDataMaintenanceType.SalesText}
        getDataList={getSalesText}
        moduleType={EModuleType.Datamaintainance}
      />
    </>
  );
};
